import React, { useEffect } from 'react';
import { connect, useDispatch } from 'react-redux';

import {
  setSymbolActive,
  setSymbolScroll,
} from '../../containers/client/actions';
import DatagridRowGroup from './DatagridRowGroup';

function DatagridGroup(props) {
  const dispatch = useDispatch();

  const { symScroll, resource, children, className, isPc, isRoom } = props;

  useEffect(() => {
    if (symScroll) {
      // console.log(symScroll)
      scrollTo(symScroll);
      dispatch(setSymbolScroll(null));
    }
  }, [symScroll]);

  const scrollTo = (id) => {
    let _rootRow = document.getElementById(id + 'row');
    if (_rootRow) {
      _rootRow.scrollIntoView();
      _rootRow.classList.add('bg-active');
      setTimeout(() => {
        if (_rootRow) _rootRow.classList.remove('bg-active');
      }, 1500);
    }
  };

  const handleOpenModal = (sym) => {
    dispatch(setSymbolActive(sym));
  };

  return (
    <table className={className + ''}>
      <colgroup>
        <col width="5.5%"></col>
        {/** sym */}
        <col width="3.4%"></col>
        {/** tc */}
        <col width="3.4%"></col>
        {/** tran */}
        <col width="3.4%"></col>
        {/** san */}
        <col width="3.4%"></col>
        {/** gia 3 */}
        <col width="3.9%"></col>
        {/** kl 3 */}
        <col width="3.4%"></col>
        {/** giá 2 */}
        <col width="3.9%"></col>
        {/** kl 2 */}
        <col width="3.4%"></col>
        {/** gia 1 */}
        <col width="3.9%"></col>
        {/** kl 1 */}
        <col width="3.4%"></col>
        {/** gia khop */}
        <col width="4.2%"></col>
        {/** kl khop */}
        <col width="3.4%"></col>
        {/** +/- */}
        <col width="3.4%"></col>
        {/** gia 1 */}
        <col width="3.9%"></col>
        {/** kl 1 */}
        <col width="3.4%"></col>
        {/** gia 2 */}
        <col width="3.9%"></col>
        {/** kl 2 */}
        <col width="3.4%"></col>
        {/** gia 3 */}
        <col width="3.9%"></col>
        {/** kl 3 */}
        <col width="4.9%"></col>
        {/** tong kl */}
        <col width="3.8%"></col>
        {/** cao */}
        <col width="3.4%"></col>
        {/** thap */}
        <col width="3.4%"></col>
        {/** tb */}
        <col width="3.5%"></col>
        {/** nn mua */}
        <col width="3.5%"></col>
        {/** nn ban */}
        <col width="3.9%"></col>
        {/** dư mua */}
        <col width="3.9%"></col>
        {/** dư ban */}
      </colgroup>
      {children && <thead className="bb-1-haft ">{children}</thead>}
      <tbody>
        {resource &&
          !!resource.length &&
          resource.map((item, index) => (
            <DatagridRowGroup
              record={item}
              key={`${item.sym}-${index}`}
              isPc={isPc}
              isRoom={isRoom}
              handleOpenModal={handleOpenModal}
            />
          ))}
      </tbody>
    </table>
  );
}

const mapStateToProps = (state) => {
  // console.log(state.client)
  return {
    symScroll: state.client.symbolScroll,
  };
};

export default connect(mapStateToProps)(DatagridGroup);
